import "../stylesheets/style_front_seminar";
require("modules/mypage/datetime");
var $ = require("jquery");
import "swiper/swiper-bundle.min.js";
require("modules/front/seminar/common.js");

$(document).ready(function () {
  // 検索時、未入力ならlocation.hrefで遷移
  $(".js--form-submit").on("click", function (e) {
    e.preventDefault();

    var seminarKeyword = $("input[name='seminar_keyword']").val();
    var seminarCategory = $("select[name='seminar_category_id']").val();
    var area = $("select[name='area']").val();
    var startDate = $("input[name='start_date']").val();
    var endDate = $("input[name='end_date']").val();

    if (seminarKeyword === "" && seminarCategory === "" && area === "" && startDate === "" && endDate === "") {
      location.href = "/seminars/result";
    } else {
      $(this).closest("form").submit();
    }
  });

  $(".js-form-clear").on("click", function (e) {
    $("input[name='seminar_keyword']").val("");
    $("select[name='seminar_category_id']").val("");
    $("select[name='area']").val("");
    $("input[name='start_date']").val("");
    $("input[name='end_date']").val("");
  });

  // 並び替え機能
  $(".js-sort").on("change", function () {
    var sortValue = $(this).val();
    var url = new URL(window.location.href);

    url.searchParams.set("sort", sortValue);
    url.hash = "seminar-headline";
    window.location.href = url.toString();
  });

  // 並び替え時、即座にスクロールさせる
  if (window.location.hash === "#seminar-headline") {
    var target = $(window.location.hash);
    if (target.length) {
      var headerHeight = $("header").outerHeight();
      // DOMが準備完了したらスクロール
      window.scrollTo({
        top: target.offset().top - headerHeight - 20,
        behavior: "smooth"
      });
    }
  }
});
